// Bilingual label dictionaries (NFR6). Keys are stable; values localized.
export type Locale = "th" | "en";

export const MESSAGES = {
  th: {
    appName: "แผนเกษียณ",
    signIn: "เข้าสู่ระบบ",
    signOut: "ออกจากระบบ",
    dashboard: "แดชบอร์ด",
    assumptions: "สมมติฐาน",
    projection: "จะเกษียณได้เมื่อไหร่?",
    montecarlo: "จำลองมอนติคาร์โล",
    accounts: "บัญชี (กรอกเอง)",
    netWorth: "มูลค่าสุทธิ",
    addAccount: "เพิ่มบัญชี",
    edit: "แก้ไข",
    editAccount: "แก้ไขบัญชี",
    name: "ชื่อ",
    type: "ประเภท",
    currentValue: "มูลค่าปัจจุบัน",
    cancel: "ยกเลิก",
    delete: "ลบ",
    confirmDelete: "ลบบัญชีนี้?",
    onTrack: "ตามแผน",
    caution: "ระวัง",
    behind: "ต่ำกว่าแผน",
    save: "บันทึกและคำนวณใหม่",
    preview: "ประมาณการ",
    confirmed: "ยืนยันแล้ว",
    syncing: "กำลังซิงค์…",
    currentAge: "อายุปัจจุบัน",
    targetRetirementAge: "อายุที่ต้องการเกษียณ",
    currentSavings: "เงินออมปัจจุบัน",
    monthlyContribution: "เงินสะสมต่อเดือน",
    targetAnnualSpending: "ค่าใช้จ่ายต่อปีหลังเกษียณ",
    expectedReturn: "ผลตอบแทนคาดหวัง",
    inflation: "เงินเฟ้อ",
    swr: "อัตราถอนปลอดภัย",
    planToAge: "วางแผนถึงอายุ",
    probabilityLast: "โอกาสที่เงินจะพอถึงอายุ",
    viewDataTable: "ดูตารางข้อมูล",
    textSummary: "สรุปเป็นข้อความ",
    skipToMain: "ข้ามไปยังเนื้อหาหลัก",
    loading: "กำลังโหลด…",
    retry: "ลองใหม่",
    somethingWrong: "เกิดข้อผิดพลาด",
    real: "มูลค่าจริง (ปรับเงินเฟ้อ)",
    savingsProjection: "การคาดการณ์เงินออม",
    age: "อายุ",
    median: "กลาง (p50):",
    pessimistic: "แย่สุด (p10):",
    optimistic: "ดีสุด (p90):",
    emptyAccounts: "เพิ่มบัญชีแรกเพื่อดูมูลค่าสุทธิ",
    setAssumptions: "ตั้งค่าสมมติฐานเพื่อดูการคาดการณ์",
    simulating: "กำลังจำลอง…",
    stressTests: "ทดสอบภาวะวิกฤต",
    stressBase: "ปกติ",
    stressMarketCrash: "ตลาดร่วง",
    stressHighInflation: "เงินเฟ้อสูง",
    stressCombined: "รวมกัน",
    runs: "รอบ",
    years: "ปี",
    targetAfterCurrent: "อายุที่ต้องการเกษียณต้องมากกว่าอายุปัจจุบัน",
    dataPrivate: "ข้อมูลของคุณเป็นส่วนตัวและเข้ารหัส",
    sections: "ส่วนต่าง ๆ",
    language: "ภาษา",
  },
  en: {
    appName: "Retirement Planner",
    signIn: "Sign in",
    signOut: "Sign out",
    dashboard: "Dashboard",
    assumptions: "Assumptions",
    projection: "When can I retire?",
    montecarlo: "Monte Carlo",
    accounts: "Accounts (manual)",
    netWorth: "Net worth",
    addAccount: "Add account",
    edit: "Edit",
    editAccount: "Edit account",
    name: "Name",
    type: "Type",
    currentValue: "Current value",
    cancel: "Cancel",
    delete: "Delete",
    confirmDelete: "Delete this account?",
    onTrack: "ON TRACK",
    caution: "CAUTION",
    behind: "BEHIND",
    save: "Save & recalculate",
    preview: "Preview",
    confirmed: "Confirmed",
    syncing: "syncing…",
    currentAge: "Current age",
    targetRetirementAge: "Target retirement age",
    currentSavings: "Current savings",
    monthlyContribution: "Monthly contribution",
    targetAnnualSpending: "Target annual spending in retirement",
    expectedReturn: "Expected nominal return",
    inflation: "Inflation",
    swr: "Safe withdrawal rate",
    planToAge: "Plan to age",
    probabilityLast: "Probability your funds last to age",
    viewDataTable: "View data table",
    textSummary: "Text summary",
    skipToMain: "Skip to main content",
    loading: "Loading…",
    retry: "Retry",
    somethingWrong: "Something went wrong",
    real: "real (inflation-adjusted)",
    savingsProjection: "Savings projection",
    age: "Age",
    median: "Median (p50):",
    pessimistic: "Pessimistic (p10):",
    optimistic: "Optimistic (p90):",
    emptyAccounts: "Add your first account to see your net worth.",
    setAssumptions: "Set your assumptions to see the projection.",
    simulating: "Simulating…",
    stressTests: "Stress tests",
    stressBase: "Base",
    stressMarketCrash: "Market crash",
    stressHighInflation: "High inflation",
    stressCombined: "Combined",
    runs: "runs",
    years: "yr",
    targetAfterCurrent: "Target retirement age must be greater than current age",
    dataPrivate: "Your data is private and encrypted.",
    sections: "Sections",
    language: "Language",
  },
} as const;

export type MessageKey = keyof (typeof MESSAGES)["en"];
